(function() {
    var iso8601 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/;

    function isIso8601(value) {
        return angular.isString(value) && iso8601.test(value);
    }

    function convertToDate(input) {
        if (!angular.isObject(input)) {
            return input;
        }

        angular.forEach(input, function (value, key) {
            if (isIso8601(value)) {
                input[key] = new Date(value);
            } else if (angular.isObject(value)) {
                convertToDate(value);
            }
        });
    }

    /* @ngInject */
    function DateInterceptor() {
        return {
            'response': function (response) {
                convertToDate(response.data);
                return response;
            }
        };
    }

    /* @ngInject */
    function DateInterceptorConfig($httpProvider) {
        $httpProvider.interceptors.push(DateInterceptor);
    }

    angular.module('egAngularUtils').config(DateInterceptorConfig);
}());